import { render, staticRenderFns } from "./Psychological.vue?vue&type=template&id=c7114416&scoped=true&"
import script from "./Psychological.vue?vue&type=script&lang=js&"
export * from "./Psychological.vue?vue&type=script&lang=js&"
import style0 from "./Psychological.vue?vue&type=style&index=0&id=c7114416&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7114416",
  null
  
)

export default component.exports